export function convertKeysToCamelCase(value: any): any {
    if (Array.isArray(value)) {
        return value.map(item => convertKeysToCamelCase(item));
    }

    if (value !== null && typeof value === 'object') {
        return Object.keys(value).reduce((result: any, key: string) => {
            const camelCaseKey = toCamelCase(key);
            result[camelCaseKey] = convertKeysToCamelCase(value[key]);
            return result;
        }, {});
    }
    return value;
}


export function toCamelCase(key: string): string {
    return key.charAt(0).toLowerCase() + key.slice(1);
}
